import { render, staticRenderFns } from "./StepFinishOrder.vue?vue&type=template&id=0df9a7a5&"
import script from "./StepFinishOrder.vue?vue&type=script&lang=js&"
export * from "./StepFinishOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports